import React from 'react';
import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { roundInfoStore } from '@pascal/pascal-core/shared/core/store';
import { useTranslation } from '@pascal/pascal-core';
import { gameStore } from '../../../store/gameStore';
import WebRoundStepInfo from '../../../components/web/gameSection/roundStepInfo';
import MobileRoundStepInfo from '../../../components/mobile/gameSection/roundStepInfo';
import { TKeys } from '../../../enums';

const AutoBetAndRoundStepInfoComp = observer(({ isMobile }) => {
  const t = useTranslation();
  const { roundId } = roundInfoStore;
  const { time, timerDuration: duration } = gameStore;

  const step = useMemo(() => {
    const calculatePercentOfTheTime = Math.round((duration * 30) / 100);
    if (+time > +calculatePercentOfTheTime) {
      return t(TKeys.placeYourBets);
    }
    if (!time || time === 0) {
      return t(TKeys.betsAreClosed);
    }
    if (+time <= +calculatePercentOfTheTime) {
      return t(TKeys.betsAreClosing);
    }

    return t(TKeys.betsAreClosed);
  }, [time, duration, t]);

  if (isMobile) {
    return <MobileRoundStepInfo roundId={roundId} step={step} />;
  }

  return <WebRoundStepInfo roundId={roundId} step={step} />;
});

export default AutoBetAndRoundStepInfoComp;
